import { Box, Stack, TableCell, Typography, IconButton } from '@mui/material';

import { AgentAvatar } from 'src/pages/csat/components/csat-survey-details-dialog';

import { Iconify } from 'src/components/iconify';

type Props = {
  columnId: string;
  row: any;
  headerIndex: number;
  t?: any;
  handlePreview?: (row: any) => void;
  rowInteractionLocked?: boolean;
};

export function RowCellCsatAgentScores({
  columnId,
  row,
  headerIndex,
  t,
  handlePreview,
  rowInteractionLocked,
}: Props) {
  const value = row[columnId];

  if (columnId === 'agent') {
    const agent = row.agent;
    return (
      <TableCell key={columnId || headerIndex} sx={{ whiteSpace: 'nowrap' }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <AgentAvatar
            profileUrl={agent?.profileUrl}
            name={agent?.name || agent?.firstName || 'A'}
            sx={{ width: 32, height: 32, fontSize: '0.85rem' }}
          />
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: 12 }}>
              {agent?.name ||
                `${agent?.firstName || ''} ${agent?.lastName || ''}`.trim() ||
                'Agent'}
            </Typography>
            {agent?.email && (
              <Typography
                variant="caption"
                sx={{ color: 'text.secondary', display: 'block', fontSize: 10 }}
              >
                {agent.email}
              </Typography>
            )}
          </Box>
        </Stack>
      </TableCell>
    );
  }

  if (columnId === 'avgCsat') {
    return (
      <TableCell key={columnId || headerIndex} sx={{ fontSize: 12 }}>
        {row.avgCsat != null ? row.avgCsat.toFixed(2) : '—'}
      </TableCell>
    );
  }

  if (columnId === 'avgSentiment') {
    return (
      <TableCell key={columnId || headerIndex} sx={{ fontSize: 12 }}>
        {row.avgSentiment != null ? row.avgSentiment.toFixed(2) : '—'}
      </TableCell>
    );
  }

  if (columnId === 'totalConversations') {
    return (
      <TableCell key={columnId || headerIndex} sx={{ fontSize: 12 }}>
        {row.totalConversations ?? 0}
      </TableCell>
    );
  }

  if (columnId === 'escalationRate') {
    return (
      <TableCell key={columnId || headerIndex} sx={{ fontSize: 12 }}>
        {row.escalationRate != null ? `${(row.escalationRate * 100).toFixed(1)}%` : '—'}
      </TableCell>
    );
  }

  if (columnId === 'action') {
    return (
      <TableCell key={columnId || headerIndex} align="right">
        <IconButton
          size="small"
          disabled={rowInteractionLocked}
          onClick={() => handlePreview?.(row)}
          aria-label={t ? t('CSAT_DASH_REFRESH_SCORE') : 'Refresh Score'}
        >
          <Iconify icon="mdi:refresh" width={20} />
        </IconButton>
      </TableCell>
    );
  }

  return null;
}
